import { AdZone, CoreAdBannerWrapper } from '../../rql';
import { AdClick, AdImpression, AdObserved, MParticleEventName } from '../../elog/mparticle_types';

export function adBannerMparticleData(
  ad: CoreAdBannerWrapper.Ad,
  adZones?: AdZone[],
) {
  return {
    adCampaignUuid: ad?.adCampaignUuid,
    adGroupUuid: ad?.adGroupUuid,
    adGroupName: ad?.adGroupName,
    advertiserUuid: ad?.advertiserUuid,
    adId: ad?.uuid,
    adUuid: ad?.uuid,
    format: ad?.format,
    title: ad?.imageAdCreative?.title,
    adZoneSlugs: adZones?.map(adZone => adZone.slug).sort().join('|'), // alphabetized to provide consistent analytics
  };
}

// fired when a user "views" an Ad according to the IntersectionObserver API
export function buildAdObservedData(
  ad: CoreAdBannerWrapper.Ad,
  componentName: string,
  adZones?: AdZone[],
): AdObserved {
  return ({
    ...adBannerMparticleData(ad, adZones),
    componentName,
    eventName: MParticleEventName.AdObserved,
  });
}

export function buildAdImpressionData(
  ad: CoreAdBannerWrapper.Ad,
  componentName: string,
  adZones?: AdZone[],
): AdImpression {
  return ({
    ...adBannerMparticleData(ad, adZones),
    componentName,
    eventName: MParticleEventName.AdImpression,
  });
}

export function buildAdClickData(
  ad: CoreAdBannerWrapper.Ad,
  componentName: string,
  adZones?: AdZone[],
): AdClick {
  return ({
    ...adBannerMparticleData(ad, adZones),
    componentName,
    eventName: MParticleEventName.AdClick,
  });
}
